import { PassTicketsFeatures } from "./features"
import dynamic from "next/dynamic"

const Lottie = dynamic(() => import("lottie-react"), {
    ssr: false,
})

const ServiceCard = ({ service, media, description }: PassTicketsFeatures) => {
    return (
        <>
            <div className="hidden h-52 w-44 rounded-3xl bg-white lg:flex lg:h-56 lg:w-96 lg:px-4">
                <div className="flex h-full w-full flex-col items-center justify-center gap-2">
                    <p className="text-center text-xs text-black lg:text-xl">
                        {service}
                    </p>
                    <div className="h-20 w-20 lg:h-24 lg:w-32">
                        <Lottie
                            loop={true}
                            animationData={media}
                            className="h-24"
                        />
                    </div>
                    <p className="pt-2 text-center text-xs text-black lg:text-base">
                        {description}
                    </p>
                </div>
            </div>
        </>
    )
}

export default ServiceCard
